import React, { useState } from "react";

import { Button, notification } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSendOtpMutation, useVerifyOtpMutation } from "store/api";

import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "components/Common/InputField";
import { ErrorAlert, OTPCountdown } from "components/Common";

const VerifyOtp: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = React.useState<string | null>(null);

  const [verifyOtp, { isLoading }] = useVerifyOtpMutation();
  const [startCounting, setStartCounting] = useState(false);

  const [sendOtp, { isLoading: isSendingOtp }] = useSendOtpMutation();

  const sendOtpHandler = async () => {
    try {
      await sendOtp({ email: location?.state?.email }).unwrap();

      notification.success({
        message: "OTP sent",
        description:
          "OTP has been sent to your, Please check your registered email inbox",
      });
    } catch (error: any) {
      setError(
        error?.data?.error || "Failed to send OTP. Please try again later.",
      );
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full h-full flex flex-col justify-center">
        <div>
          <h1 className="text-2xl font-bold mb-4">Verify OTP</h1>
          <p className="mb-4">
            Please enter the OTP sent to your email address
          </p>
        </div>

        <Formik
          validateOnBlur
          initialValues={{
            otp: "",
            email: location?.state?.email || "",
          }}
          validationSchema={Yup.object().shape({
            otp: Yup.string().required("OTP is required"),
          })}
          onSubmit={async (values) => {
            try {
              await verifyOtp({
                otp: +values.otp,
                email: values.email,
                endpoint: "verify-otp",
              }).unwrap();
              notification.success({
                message: "OTP Verified",
                description: "OTP verified successfully",
              });

              navigate("/unlock-account", {
                state: { email: location?.state?.email },
              });
            } catch (error: any) {
              setError(error?.data?.error);
            }
          }}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <form onSubmit={handleSubmit} className="space-y-3">
              <ErrorAlert type="error" message={error} setMessage={setError} />
              <InputField
                label="OTP"
                name="otp"
                type="text"
                placeholder="Enter OTP"
              />
              <OTPCountdown
                start={startCounting}
                setStart={setStartCounting}
                expiryMinutes={10}
                onResend={sendOtpHandler}
                isSendingOtp={isSendingOtp}
              />
              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-10"
                loading={isLoading}
                disabled={!isValid || !dirty || isLoading}
              >
                Verify OTP
              </Button>
              <div className="flex items-center justify-end p-3 gap-2">
                <Link to="/" className="text-blue-500">
                  Back to login
                </Link>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default VerifyOtp;
